import { queryKeys } from "@/lib/useQuery/queryKeys";
import { useQuery } from "@tanstack/react-query";
import { GetAllSurveyBankTemplatesProps } from ".";

export function useGetAllSurveyBankTemplates({whereCrmSystems, orgId}: GetAllSurveyBankTemplatesProps) {
    return useQuery({
        ...queryKeys.survey_bank.list(orgId)._ctx.byCrmSystemsArr(whereCrmSystems),
    });
}